import { ActionContext } from 'vuex'
import apiAdminMesureUnite from '@/api/admin/mesureUnite'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IMesureUniteState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloDbMesureUnite } from '@/models/alodb/AloDbMesureUnite'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class MesureUniteAction {
  public [types.MESUREUNITE_REQUEST](context: ActionContext<IMesureUniteState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MESUREUNITE_REQUEST)
      apiAdminMesureUnite
        .getMesureUnites()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const mesureUniteArray = resp.data.data as AloBaseArray<AloDbMesureUnite>
            context.commit(types.MESUREUNITE_SUCCESS, mesureUniteArray.items)
            resolve(mesureUniteArray.items)
          } else {
            context.commit(types.MESUREUNITE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.MESUREUNITE_ERROR)
          reject()
        })
    })
  }

  public [types.MESUREUNITE_ENSURE_LIST](context: ActionContext<IMesureUniteState, IRootState>) {
    if (context.state.mesureUnites.length == 0) {
      return context.dispatch(types.MESUREUNITE_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.mesureUnites)
      })
    }
  }

  public [types.MESUREUNITE_SELECT_DETAIL](context: ActionContext<IMesureUniteState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      const mesureUnite = context.getters.mesureUnitesById[itemId] as AloDbMesureUnite
      if (mesureUnite) {
        if (mesureUnite.detailLoaded) {
          context.commit(types.MESUREUNITE_SELECT_DETAIL, mesureUnite)
          resolve(mesureUnite)
        } else {
          context.dispatch(types.MESUREUNITE_SELECT_DETAIL_REQUEST, itemId).then(ens => {
            context.commit(types.MESUREUNITE_SELECT_DETAIL, ens)
            resolve(ens)
          })
        }
      } else {
        const newMesureUnite = new AloDbMesureUnite()
        context.commit(types.MESUREUNITE_SELECT_DETAIL, newMesureUnite)
        resolve(newMesureUnite)
      }
    })
  }

  public [types.MESUREUNITE_SELECT_DETAIL_REQUEST](
    context: ActionContext<IMesureUniteState, IRootState>,
    itemId: number
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MESUREUNITE_SELECT_DETAIL_REQUEST, itemId)
      apiAdminMesureUnite
        .getMesureUnite(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const mesureUnite = resp.data.data as AloDbMesureUnite
            context.commit(types.MESUREUNITE_SELECT_DETAIL_SUCCESS, mesureUnite)
            context.commit(types.MESUREUNITE_SELECT_DETAIL, mesureUnite)
            resolve(mesureUnite)
          } else {
            context.commit(types.MESUREUNITE_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.MESUREUNITE_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.MESUREUNITE_SAVE_REQUEST](context: ActionContext<IMesureUniteState, IRootState>) {
    return new Promise((resolve, reject) => {
      const tryRedirect = !context.state.modifiedAdmMesureUnite.id
      context.commit(types.MESUREUNITE_SAVE_REQUEST, context.state.modifiedAdmMesureUnite.MUT_LIBELLE)
      apiAdminMesureUnite
        .saveMesureUnite(context.state.modifiedAdmMesureUnite)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const mesureUnite = resp.data.data as AloDbMesureUnite
            context.commit(types.MESUREUNITE_SELECT_DETAIL_SUCCESS, mesureUnite)
            context.commit(types.MESUREUNITE_SELECT_DETAIL, mesureUnite)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:mesureUnite.MUT_LIBELLE}))                      
            if (tryRedirect && router.app.$route.name === 'NewMesureUnite')
              router.push({ name: 'EditMesureUnite', params: { itemid: mesureUnite.id!.toString() } })
            resolve(mesureUnite)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MESUREUNITE_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MESUREUNITE_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.MESUREUNITE_UPDATE_MODIFIED_ADM](
    context: ActionContext<IMesureUniteState, IRootState>,
    newProperties: Object
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MESUREUNITE_UPDATE_MODIFIED_ADM, newProperties)
      resolve(context.state.modifiedAdmMesureUnite)
    })
  }

  public [types.MESUREUNITE_CANCEL_MODIFIED_ADM](context: ActionContext<IMesureUniteState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MESUREUNITE_SELECT_DETAIL, context.state.originalAdmMesureUnite)
      resolve(context.state.modifiedAdmMesureUnite)
    })
  }

  public [types.MESUREUNITE_UPDATE_FILTER_ADM](
    context: ActionContext<IMesureUniteState, IRootState>,
    newProperties: Object
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MESUREUNITE_UPDATE_FILTER_ADM, newProperties)
      resolve(context.state.adminFilter)
    })
  }
}

export default util.classToObject(MesureUniteAction)
